import { Button } from '@/components/ui'
import { useToast } from '@/hooks'
import { ProjectCaseFields } from './ProjectCaseFields'
import { useProjectCaseForm } from './useProjectCaseForm'

interface EditCaseFormProps {
  isSaving: boolean
  onSavingChange: (isSaving: boolean) => void
  onClose: () => void
}

// Mounted only while the dialog is open, so it always starts from the saved answers and
// never writes an old copy over an edit made elsewhere.
export const EditCaseForm = ({
  isSaving,
  onSavingChange,
  onClose,
}: EditCaseFormProps) => {
  const { successToast, errorToast } = useToast()
  const form = useProjectCaseForm()

  const submit = () => {
    onSavingChange(true)
    form
      .save()
      .then(() => {
        onClose()
        successToast('Case details updated')
      })
      .catch((error) => errorToast('Couldn’t save the case details', error))
      .finally(() => onSavingChange(false))
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        submit()
      }}
    >
      <div className="py-4">
        <ProjectCaseFields form={form} />
      </div>
      <div className="flex justify-end gap-2">
        <Button theme="outline" onClick={onClose} disabled={isSaving}>
          Cancel
        </Button>
        <Button type="submit" isLoading={isSaving} disabled={!form.isLoaded}>
          Save
        </Button>
      </div>
    </form>
  )
}
